// Which slot hints a hero shows while the party plans. Every hero has two actions, so two slots
// always show; the bonus slot is not a third hint (playtesters read three boxes as three actions).
// It shows, marked with a star, only once the hero plans a real bonus action (not a Hold, not one
// the lock filled in), or while the player has it open to pick one.
import type { Slot } from '../../core/sim/types';

/** The star a planned bonus action is marked with, wherever slot numbers are shown. */
export const BONUS_MARK = '★';

/** The label of a slot: its number, or the bonus star. */
export const slotMark = (s: Slot): string => (s === 'B' ? BONUS_MARK : String(s));

interface Planned { action: number; substituted?: boolean }

/** Whether `heroId` plans a bonus action this pulse: a real one, not a Hold (action 2) or a substituted one. */
export function plansBonus(heroId: number, local: ReadonlyMap<string, Planned>, rows: ReadonlyMap<string, Planned>): boolean {
  const it = local.get(`${heroId}:B`) ?? rows.get(`${heroId}:B`);
  return !!it && it.action !== 2 && !it.substituted;
}

/** The slots to draw for `heroId`: 1 and 2 always, the bonus only when planned (or `open`, being chosen). */
export function slotHints(heroId: number, local: ReadonlyMap<string, Planned>, rows: ReadonlyMap<string, Planned>, open?: Slot): Slot[] {
  return plansBonus(heroId, local, rows) || open === 'B' ? [1, 2, 'B'] : [1, 2];
}
